import { render, staticRenderFns } from "./AdmissionInfo.vue?vue&type=template&id=2abc2f97&"
import script from "./AdmissionInfo.vue?vue&type=script&lang=js&"
export * from "./AdmissionInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionInfo.vue?vue&type=style&index=0&id=2abc2f97&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports